import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';

import { QuickSaleModel } from '../models/QuickSaleModel';
import { getQuickSale } from '../services/QuickSaleCRUD';
import { apiErrorMessage } from '../utils/quickSaleFormat';

export function useQuickSale(userId: number) {
  const intl = useIntl();
  const [data, setData] = useState<QuickSaleModel | null>(null);
  const [loading, setLoading] = useState(false);

  async function load() {
    if (!userId) {
      return;
    }
    setLoading(true);
    try {
      const response = await getQuickSale(userId);
      setData(response.data);
    } catch (error) {
      toast.error(
        apiErrorMessage(
          error,
          intl.formatMessage({ id: 'quickSale.loadError' })
        )
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setData(null);
    // `load` only reads `userId`, which is the dependency.
    load();
  }, [userId]);

  return { data, loading, reload: load };
}
